import { TaskSimpleCardController } from './task-simple-card.controller'

function taskSimpleCard () {
  return {
    restrict: 'E',
    scope: {
      task: '<',
      selected: '<',
      options: '<',
      parentTask: '<'
    },
    templateUrl: '/workflow/directives/task-simple-card/task-simple-card-directive.html?$$REVISION$$',
    controller: TaskSimpleCardController
  }
}

export { taskSimpleCard }
